import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Form } from "antd";
import { JPInputRadioShapeProps } from "./jpInputRadioShape.model";
import "@companion-core/web/src/Assets/Styles/scss/radiobutton.scss";
import { TextInShape } from "@companion-core/shared/app/Components/TextInShape";
import { JPInputError } from "@companion-core/shared/app/Components/Inputs/JPInputError";
import "@companion-core/web/src/Assets/Styles/scss/inputradioshape.scss";

export const JPInputRadioShape: React.FC<JPInputRadioShapeProps> = ({
  name,
  options,
  value,
  payloadPath = name,
  testID,
  required,
  registerValidation,
  setFieldErrors,
  onValueChange,
}: JPInputRadioShapeProps) => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const [error, setError] = useState<string>("");
  const [inputValue, setInputValue] = useState<string>(value);
  const inputValueRef = useRef(inputValue); // Create a ref to store the latest value and avoid stale closure

  useEffect(() => {
    if (registerValidation) registerValidation(name, validateInput);
  }, []);

  useEffect(() => {
    inputValueRef.current = inputValue; // Update ref value
  }, [inputValue]);

  useEffect(() => {
    if (form && payloadPath) {
      form.setFieldsValue({
        [payloadPath]: inputValue,
      });
    }
    if (onValueChange) {
      onValueChange(inputValue);
    }
  }, [onValueChange, inputValue, form, payloadPath]);

  const validateInput = () => {
    const err = !inputValueRef.current && required ? "common.form.input.error.required" : "";
    setError(err);
    if (setFieldErrors) setFieldErrors(err ? [err] : []);
  };

  return (
    <>
      {error && <JPInputError inputLabel={t(name)} testID={testID} error={error} position="top" />}
      <ul data-testid={testID} className="radioshape-input">
        {options.map((option) => (
          <li key={`radioshape-${name}-${option.value}`} className="radioshape-input__button">
            <TextInShape
              ariaLabel={t(option.text)}
              value={option.value}
              testID={`${testID}-radioshape`}
              text={t(option.text)}
              size={"small"}
              onClick={() => setInputValue(option.value)}
              selected={inputValue === option.value}
            />
          </li>
        ))}
      </ul>
    </>
  );
};
